import { useFeatureAccess } from "../../../access-control/hooks/useFeatureAccess";
import { FEATURE_KEYS } from "../../../access-control/models/role-feature.models";
import { themeAtom } from "../../../shared/atoms";
import { ADMIN_PATHS } from "../../models/admin.models";
import { useAtomValue } from "jotai";
import { NavLink } from "react-router-dom";
import { twMerge } from "tailwind-merge";

const AdminUwhcViewTabs = () => {
  const theme = useAtomValue(themeAtom);
  const { hasFeature } = useFeatureAccess();

  const tabs = [
    {
      label: "UWHC Vendors",
      path: ADMIN_PATHS.uwhc,
      requiredFeatureKey: FEATURE_KEYS.ADMIN_REF_PARAMETERS_UWHC_VENDORS,
    },
  ].filter((tab) => hasFeature(tab.requiredFeatureKey));

  if (tabs.length <= 1) {
    return null;
  }

  return (
    <div className="border-b border-[#E6ECEA] bg-white px-8 pt-6" data-test="admin-uwhc-view-tabs">
      <nav aria-label="UWHC admin views" className="flex flex-wrap gap-8">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            end={tab.path === ADMIN_PATHS.uwhc}
            className={({ isActive }) =>
              twMerge(
                theme.home.tailwind.textDefault,
                "border-b-2 pb-3 text-sm font-semibold transition-colors",
                isActive
                  ? "border-[#118A7E] text-[#0B7C71]"
                  : "border-transparent text-[#556270] hover:border-[#BEE4DD] hover:text-[#0B7C71]",
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default AdminUwhcViewTabs;
